import { useCallback, useEffect, useState } from 'react';
import http from 'services/http';

/**
 * Avisos da Setebit para o usuário logado no painel.
 *
 * Uma única chamada (GET avisos/nao-lidos) alimenta o sino do cabeçalho e o
 * modal do aviso crítico — são as duas faces do mesmo dado, e o endpoint da API
 * já devolve contador, últimos avisos e críticos não lidos juntos.
 *
 * Aviso não é dado de tempo real: recarrega no mount e a cada 5 minutos, para
 * não gastar o limite de 30 requisições por minuto da API com polling curto.
 */
const INTERVALO_MS = 5 * 60 * 1000;

export default function useAvisos() {
	const [naoLidos, setNaoLidos] = useState(0);
	const [ultimos, setUltimos] = useState([]);
	const [criticos, setCriticos] = useState([]);

	const carregar = useCallback(async () => {
		try {
			const { data: { data } } = await http.get('avisos/nao-lidos');
			setNaoLidos(data?.nao_lidos ?? 0);
			setUltimos(data?.ultimos ?? []);
			setCriticos(data?.criticos ?? []);
		} catch (e) {
			// Aviso é acessório: falha de rede não pode atrapalhar o painel.
		}
	}, []);

	useEffect(() => {
		carregar();
		const intervalo = setInterval(carregar, INTERVALO_MS);

		// A tela /avisos marca leituras por conta própria e avisa por este evento,
		// para o contador do sino cair na hora em vez de esperar o próximo ciclo.
		window.addEventListener('avisos:atualizados', carregar);

		return () => {
			clearInterval(intervalo);
			window.removeEventListener('avisos:atualizados', carregar);
		};
	}, [carregar]);

	const marcarLido = useCallback(async (id) => {
		try {
			await http.post(`avisos/${id}/lido`);
		} catch (e) {
			// silencia: o recarregar abaixo devolve o estado real do servidor
		}
		await carregar();
	}, [carregar]);

	const marcarTodosLidos = useCallback(async () => {
		try {
			await http.post('avisos/lidos');
		} catch (e) {}
		await carregar();
	}, [carregar]);

	return { naoLidos, ultimos, criticos, carregar, marcarLido, marcarTodosLidos };
}
